import { forwardRef } from "react";
import { Icon } from "@newsela/angelou";
import ArrowLineLeftSvg from "./ArrowLineLeft.svg.jsx";

const ArrowLineLeft = forwardRef<SVGSVGElement, any>((props, ref) => {
  return <Icon ref={ref} SvgComponent={ArrowLineLeftSvg} {...props} />;
});

ArrowLineLeft.displayName = "ArrowLineLeft";
export default ArrowLineLeft;
